export default __webpack_public_path__ + "static/media/not-active-contacts.d25cc365.svg";